export default __webpack_public_path__ + "static/media/670.d23bd2ba.png";